import Big from "big.js";

import { decimalToThreePlaces } from "@eave/shared/utils/numbers";
import { LoanApplicationRate, RateTables } from "@eave/shared/types/api";
import { compareTimestampOrNull } from "./date";

export const get60DayLockParRateFromRate = (rateTable: RateTables) => {
  let lock60 = rateTable.lock_periods["60"].find(rate => rate.par);

  if (!lock60) {
    lock60 = { ...rateTable.lock_periods["60"][0] };
  }
  return decimalToThreePlaces(lock60.rate);
};

export const rateIsLocked = (applicationRate: LoanApplicationRate) => {
  return (
    applicationRate !== null &&
    applicationRate.locked &&
    compareTimestampOrNull(applicationRate.expires_at, new Date()) === 1 // expires_at is AFTER current date
  );
};
/** Returns the discount dollar amount for a given rate
 * @param  {LoanApplicationRate} applicationRate
 * @param  {string} loanAmount
 * @returns string
 */
export const calculateDiscountAmount = (
  applicationRate: LoanApplicationRate,
  loanAmount: string,
): string => {
  if (
    applicationRate?.rate_basis?.price_delta &&
    Number(applicationRate.rate_basis.price_delta) !== 0
  ) {
    return Big(loanAmount)
      .mul(Big(applicationRate.rate_basis.price_delta).div(Big(100)))
      .abs()
      .round(2)
      .toString();
  }
  return "0";
};
